import { FC } from "react";
import { Button, Flex, Spacer } from "components";
import { WizardOptions } from "import/components/WizardOptions";
import { BatchUploadFormat } from "hooks/useGetBatchUploadFormats";
import { useHasFeature } from "hooks/useHasFeature";

interface Props {
  activityTypeId: string;
  onClickBack: () => void;
  onSelect: (batchUploadFormat: BatchUploadFormat) => void;
  batchUploadFormats: BatchUploadFormat[];
}

export const ImportWizardChooseTemplate: FC<Props> = ({
  activityTypeId,
  onClickBack,
  onSelect,
  batchUploadFormats,
}) => {
  const hasMoveOffCsvUploadFeature = useHasFeature("MOVE_OFF_DRAFT_CSV_IMPORT");

  const batchUploadFormatsForType = batchUploadFormats.filter(
    (activityTemplate) => activityTemplate.activityType?.id === activityTypeId,
  );

  const filteredActivityTemplates = batchUploadFormatsForType.filter((activityTemplate) => {
    if (hasMoveOffCsvUploadFeature && activityTemplate.slug === "activity-move-off-farm") {
      return false;
    } else if (!hasMoveOffCsvUploadFeature && activityTemplate.slug === "cmd-deliver-out") {
      return false;
    } else {
      return true;
    }
  });

  return (
    <>
      <WizardOptions>
        {filteredActivityTemplates.map((batchUploadFormat) => {
          const handleClick = () => onSelect(batchUploadFormat);

          return (
            <WizardOptions.Option
              key={batchUploadFormat.slug}
              name={batchUploadFormat.name || batchUploadFormat.slug}
              onClick={handleClick}
            />
          );
        })}
      </WizardOptions>

      <Spacer baselineHeight={4} />

      <Flex container containerJustifyContent="space-between">
        <Button caption="Back" colour="grey" onClick={onClickBack} variant="hollow" />
      </Flex>
    </>
  );
};
